export default __webpack_public_path__ + "static/media/napoj-orange.ecb949c9.jpg";